import React, { useEffect } from "react";
import { useParams, useHistory } from "react-router-dom"

// reactstrap components
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Collapse,
  CustomInput,
  Row,
  UncontrolledDropdown, 
  DropdownToggle, 
  DropdownMenu, 
  DropdownItem,
  Pagination,
  PaginationItem, 
  PaginationLink
} from "reactstrap";

import {
  Box,
  Button,
  IconButton,
  Table,
  TableBody,
  TableFooter,
  TableHead,
} from "@mui/material"

import SweetAlert from "react-bootstrap-sweetalert";
import Select from "react-select";
import HistoryTable from "components/HistoryTable/HistoryTable.js";
import ReactDatetime from "react-datetime"

import LanguageDependentText from "components/TimerTable/LanguageDependentText";
import { useHuntTrackerContext } from "tracker-context";

import Flatpickr from "react-flatpickr";

import { SocketIO } from "sessions/socket"
import { SessionConfigs } from "sessions/sessionState";
import { extractPatchInfo, extractWorldInfo, extractHuntInfo, extractFATEInfo } from "sessions/gameInfo";
import { huntInfos } from "sessions/resources/hunts.js";

const HistoryPage = () => {
  const history = useHistory();

  const [alert, setAlert] = React.useState(null);
  const [controller, dispatch] = useHuntTrackerContext();
  const { language, dataCenter, user } = controller;

  const [locale, setLocale] = React.useState(null);
  const [admin, setAdmin] = React.useState(null);
  const [huntNames, setHuntNames] = React.useState([]);
  const [worldNames, setWorldNames] = React.useState([]);
  const [patchNames, setPatchNames] = React.useState([]);
  const [rankSelected, setRankSelected] = React.useState({value: "All", label: SessionConfigs.dictionaryLookup("header", "historyFilterAllRank")});
  const [timeSelection, setTimeSelection] = React.useState({pre: new Date(), post: new Date()});
  const [searchResult, setSearchResult] = React.useState([]);
  const [filterResult, setFilterResult] = React.useState([]);

  const textLibrary = SessionConfigs.dictionaryLookup;
  const patchList = extractPatchInfo();
  const worldList = extractWorldInfo(dataCenter)["Names"];

  React.useEffect(() => {
    if (SessionConfigs.getDataCenter() == "") {
      history.push("/index", {replace: true});
    };

    if (user) {
      if (user.permission) {
        if (user.permission.AdminTable) {
          setAdmin(true);
        }
      }
    }

  }, []);

  const searchDeathReports = (event) => {
    SessionConfigs.queryData("/api/fetchDeathHistory", {
      huntNames: huntNames.map((value)=>value.value),
      worldNames: worldNames.map((value)=>value.value),
      startTime: new Date(timeSelection.pre.toLocaleDateString("en", {
        year: 'numeric', 
        month: 'numeric', 
        day: 'numeric'
      })).getTime(),
      endTime: new Date(timeSelection.post.toLocaleDateString("en", {
        year: 'numeric', 
        month: 'numeric', 
        day: 'numeric'
      })).getTime(),
    }).then((response) => {
      for (var i in response.data) {
        const huntInfo = extractHuntInfo(response.data[i].huntName);
        if (huntInfo) {
          response.data[i].Rank = huntInfo.Rank;
          response.data[i].Patch = huntInfo.Patch;
        } else if (response.data[i].huntName.startsWith("FATE")) {
          const fateInfo = extractFATEInfo(response.data[i].huntName);
          response.data[i].Rank = "FATE";
          response.data[i].Patch = fateInfo.Patch;
        } else {
          response.data[i].Rank = 5;
          response.data[i].Patch = "";
        }
      }
      setSearchResult(response.data);
    }).catch((error) => {
      setAlert(
        <SweetAlert
            error style={{display: "block",marginTop: "-100px"}}
            title="Error Received" onConfirm={() => setAlert(null)}
            onCancel={() => setAlert(null)} confirmBtnBsStyle="info" >
        {"Error"}
      </SweetAlert>);
    })
  }

  const filterSearchResults = () => {
    const worldSelected = worldNames.map((value)=>value.value);
    var filterResult = searchResult.filter((hunt) => {
      return worldSelected.includes(hunt.worldName) || worldNames.length == 0;
    });

    const huntSelected = huntNames.map((value)=>value.value);
    filterResult = filterResult.filter((hunt) => {
      return huntSelected.includes(hunt.huntName) || huntNames.length == 0;
    });
    
    const patchSelected = patchNames.map((value)=>value.value);
    filterResult = filterResult.filter((hunt) => {
      return patchSelected.includes(hunt.Patch) || patchNames.length == 0;
    });
    setFilterResult(filterResult.sort((a,b) => b.deathTime - a.deathTime));
    
    filterResult = filterResult.filter((hunt) => {
      return hunt.Rank == rankSelected.value || rankSelected.value == "All";
    });
    setFilterResult(filterResult.sort((a,b) => b.deathTime - a.deathTime));
  }

  React.useEffect(() => {
    filterSearchResults();
  }, [searchResult, huntNames, worldNames, patchNames, rankSelected]);

  return (
    <>
      <div className="content">
        {alert}
        <Row>
          <Col>
            <Card>
              <CardHeader>
                <Row>
                  <Col sm={12} md={6} lg={4}>
                    <LanguageDependentText header={"historyHuntFilter"} fontSize={15} />
                    <Select
                      className="react-select info"
                      classNamePrefix="react-select"
                      placeholder="Select Hunts"
                      name="Hunt Filter"
                      closeMenuOnSelect={false}
                      isMulti
                      isSearchable
                      minMenuHeight={600}
                      maxMenuHeight={900}
                      value={huntNames}
                      onChange={(value) => {
                        if (!value) setHuntNames([]);
                        else setHuntNames(value);
                      }}
                      options={Object.keys(huntInfos).map((key) => {
                        if (huntInfos[key].Rank != 1) {
                          return {value: key, label: textLibrary("huntName", key)};
                        }
                      }).filter((value) => value)}
                    />
                  </Col>
                  <Col sm={12} md={6} lg={4}>
                    <LanguageDependentText header={"historyWorldFilter"} fontSize={15} />
                    <Select
                      className="react-select info"
                      classNamePrefix="react-select"
                      name="World Filter"
                      closeMenuOnSelect={false}
                      isMulti
                      minMenuHeight={600}
                      maxMenuHeight={900}
                      value={worldNames}
                      onChange={(value) => {
                        if (!value) setWorldNames([]);
                        else setWorldNames(value);
                      }}
                      options={worldList.map((world)=>{
                        return {value: world, label: world}
                      })}
                    />
                  </Col>
                  <Col sm={12} md={6} lg={4}>
                    <LanguageDependentText header={"historyPatchFilter"} fontSize={15} />
                    <Select
                      className="react-select info"
                      classNamePrefix="react-select"
                      name="Patch Filter"
                      closeMenuOnSelect={false}
                      isMulti
                      minMenuHeight={600}
                      maxMenuHeight={900}
                      value={patchNames}
                      onChange={(value) => {
                        if (!value) setPatchNames([]);
                        else setPatchNames(value);
                      }}
                      options={Object.keys(patchList).map((key) => {
                        return {value: key, label: patchList[key][language]}
                      })}
                    />
                  </Col>
                  <Col sm={12} md={6} lg={4}>
                    <LanguageDependentText header={"historyRankFilter"} fontSize={15} />
                    <Select
                      className="react-select info"
                      classNamePrefix="react-select"
                      name="Rank Filter"
                      closeMenuOnSelect={true}
                      minMenuHeight={600}
                      maxMenuHeight={900}
                      value={rankSelected}
                      onChange={(value) => {
                        setRankSelected(value);
                      }}
                      options={[
                        {value: "All", label: textLibrary("header", "historyFilterAllRank")},
                        {value: 3, label: textLibrary("header", "historyFilterSRank")},
                        {value: 2, label: textLibrary("header", "historyFilterARank")},
                        {value: "FATE", label: textLibrary("header", "historyFilterFATE")},
                      ]}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm={12} md={6}>
                    <LanguageDependentText header={"historyTimeMin"} fontSize={15} />
                    <Flatpickr options={{
                      enableTime: false,
                      defaultDate: timeSelection.pre
                    }} className={"form-control datetime-picker"} onChange={([date]) => { setTimeSelection({...timeSelection, pre: new Date(date)}) }}/>
                  </Col>
                  <Col sm={12} md={6}>
                    <LanguageDependentText header={"historyTimeMax"} fontSize={15} />
                    <Flatpickr options={{
                      enableTime: false,
                      defaultDate: timeSelection.post
                    }} className={"form-control datetime-picker"} onChange={([date]) => { setTimeSelection({...timeSelection, post: new Date(date)}) }}/>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Button size="lg" variant="contained" color="secondary" onClick={searchDeathReports} style={{marginTop: 20, width: "100%"}}>
                      <LanguageDependentText header="historySearch" fontSize={20}/>
                    </Button>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <HistoryTable data={filterResult} admin={admin}/>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default HistoryPage;
